/* import __COLOCATED_TEMPLATE__ from './tag-row.hbs'; */
var _dec, _obj;
function _applyDecoratedDescriptor(i, e, r, n, l) {
  var a = {};
  return Object.keys(n).forEach(function (i) {
    a[i] = n[i];
  }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) {
    return n(i, e, r) || r;
  }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a;
}
import discourseComputed from "discourse-common/utils/decorators";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
import TEMPLATE from "./tag-row.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, SelectKitRowComponent.extend((_dec = discourseComputed("item"), (_obj = {
  classNames: ["tag-row"],
  isTag(item) {
    return item.id !== "no-tags" && item.id !== "all-tags";
  }
}, _applyDecoratedDescriptor(_obj, "isTag", [_dec], Object.getOwnPropertyDescriptor(_obj, "isTag"), _obj), _obj))));